module.exports = __webpack_public_path__ + "img/mozzo_min.c18d1720.jpeg";